import { render, staticRenderFns } from "./QuestionAdd.vue?vue&type=template&id=3be0f9e9"
import script from "./QuestionAdd.vue?vue&type=script&lang=js"
export * from "./QuestionAdd.vue?vue&type=script&lang=js"
import style0 from "./QuestionAdd.vue?vue&type=style&index=0&id=3be0f9e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports